module.exports = "/legacy/0b2419c1c97a3190618a332595c73c79.svg";